import { send } from 'server';

import * as helpers from '../../../helpers';
import { REPORT_TYPES } from '../../../constants';

export const getTaxReportPdf = ({ startDate, endDate, reportType, transactionId }) => send({
    ID: 35838,
    responses: [35839, 35840],
    description: 'Get Tax Report PDF',
    startDate: helpers.formatDateForIms(startDate),
    endDate: helpers.formatDateForIms(endDate),
    reportType,
    ...reportType === REPORT_TYPES.TRANSACTION && { transactionId }
});
